import Enums from "@/enums";
import { renderFormattedContent } from "@/utils/renderFormattedContent";
import "@style/RestartPageOverlay.scss";

type RestartPageOverlayProps = {
    restartPage: {
        sectionId?: number;
        content?: string;
        contentFormat?: number;
    };
    onContinue: () => void | Promise<void>;
    isBusy?: boolean;
};

export default function RestartPageOverlay(props: RestartPageOverlayProps) {
    const { restartPage, onContinue, isBusy = false } = props;
    const content = String(restartPage?.content || "");

    if (!content) return null;

    return (
        <div className="restartPageOverlay">
            <div className="restartPageOverlay__panel">
                <div className="restartPageOverlay__content">
                    {renderFormattedContent(content, {
                        format: restartPage?.contentFormat ?? Enums.CONTENT_FORMAT.HTML,
                    })}
                </div>
                <div className="restartPageOverlay__actions">
                    <button
                        type="button"
                        className="primaryButton restartPageOverlay__continue"
                        onClick={onContinue}
                        disabled={isBusy}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
}
